import { useState } from 'react'
import toast from 'react-hot-toast'
import { useHistory } from 'react-router-dom'
import firebase from 'firebase/compat/app'
import { useApolloClient } from '@apollo/client'
import { registerUser } from '../../graphql'
import { setShowAuthModal, useAppDispatch, useAppSelector } from '../../redux'
import { ROUTES } from '..'
import { useForm } from '.'

export const useRegister = () => {
  const history = useHistory()
  const apollo = useApolloClient()
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)
  const { authRedirect } = useAppSelector((state) => state.state)
  const { form, set, reset } = useForm({
    fullName: '',
    email: '',
    password: '',
    text: false,
    phone: '',
    plan: 'trial'
  })

  const register = async () => {
    try {
      if (!form?.fullName?.trim() || !form?.email?.trim() || !form?.password?.trim()) {
        return
      }

      setLoading(true)

      await apollo.mutate({
        fetchPolicy: 'no-cache',
        mutation: registerUser,
        variables: {
          ...form,
          academy: true
        }
      })

      await firebase.auth().signInWithEmailAndPassword(form.email, form.password)

      if (authRedirect) {
        history.push(authRedirect)
        dispatch(setShowAuthModal({ show: false, redirect: '' }))
        return
      }

      dispatch(setShowAuthModal(false))
    } catch (err) {
      console.error(err)
      toast.error((err as any)?.message)
      setLoading(false)
    }
  }

  return {
    loading,
    form,
    register,
    set,
    reset
  }
}
